package com.tovtalk.ui.theme

import androidx.compose.ui.text.font.Font
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.platform.Font as PlatformFont

actual fun fontFromBytes(
    identity: String,
    data: ByteArray,
    weight: FontWeight,
    style: FontStyle
): Font = PlatformFont(identity, data.copyOf(), weight, style)
